const TENANT_LABELS = {
  kpmg: "KPMG",
  taxdesk: "Tax Desk",
  mdc: "My Duty Collect",
  amazon: "Tax Desk"
};
export const getTenantLabel = (tenantName) => {
  if (tenantName === "kpmg") {
    return TENANT_LABELS.kpmg;
  }
  if (tenantName === "mdc") {
    return TENANT_LABELS.mdc;
  }
  if (tenantName === "amazon") {
    return TENANT_LABELS.amazon;
  }
  return TENANT_LABELS.taxdesk;
};
